import { take, tap } from 'rxjs/operators';
import { Util } from './../_classes/util';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Afastamento } from './../_classes/afastamento';
import { Observable, Subject, timer, EMPTY } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ServidorService } from '../_servicos/servidor.service';
import { RestService } from '../_servicos/rest.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-ferias',
  templateUrl: './ferias.component.html',
  styleUrls: ['./ferias.component.scss'],
})
export class FeriasComponent implements OnInit {
  private readonly recurso: string = 'ferias'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = [
    'dtInicio',
    'totalDiasAfastamento',
    'dsTipoAfastamento',
  ];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Afastamento[]>;
  dataSource: MatTableDataSource<Afastamento>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Período',
      texto: 'Período da Licença',
    },
    {
      titulo: 'Dias',
      texto: 'Quantidade de dias afastado',
    },
    {
      titulo: 'Tipo',
      texto: 'Tipo da Licença',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: Afastamento[]) {
    this.dataSource = new MatTableDataSource<Afastamento>(
      x.filter((y: Afastamento) => y.cdGrupoAfastamento === 0)
    );
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarAfastamento(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }
  /*
  atualizarOld() {
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.servidor = this.servService.getServidorAtualRedirecionando('ferias');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarAfastamento(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );
    }
  }*/

  periodo(row: Afastamento) {
    return Util.periodoMesAbreviado(row.dtInicio, row.dtFim);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
